module.exports = __webpack_public_path__ + "img/icon-eagle-white.b5d9c452.svg";